exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown .dropdown-menu[data-v-53929202] {\n  -webkit-animation-name: _fade-data-v-53929202;\n          animation-name: _fade-data-v-53929202;\n  -webkit-animation-duration: 0.5s;\n          animation-duration: 0.5s;\n}\n@-webkit-keyframes _fade-data-v-53929202 {\nfrom {\n    opacity: 0.2;\n}\nto {\n    opacity: 1;\n}\n}\n@keyframes _fade-data-v-53929202 {\nfrom {\n    opacity: 0.2;\n}\nto {\n    opacity: 1;\n}\n}", ""]);

// exports
